import {
  IconButton,
  AdminIcon,
  IconSizeEnum,
  WorkspaceIcon,
  TIcon,
  DespieceIcon,
  AVIcon,
  Tooltip,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { ACCESO360_API_URL, BASE_URL, DESPIECE_BASE_URL, AV_PLUS_BASE_URL } from '@/config';
import { I18nextTranslationKeys } from '@/i18n/i18next';

type PLATFORM = {
  link: string;
  icon: TIcon;
  tooltip: I18nextTranslationKeys;
};

const PLATFORMS: PLATFORM[] = [
  {
    link: `${ACCESO360_API_URL.replace(/\/$/, '')}/admin`,
    icon: AdminIcon,
    tooltip: 'Backoffice',
  },
  {
    link: `${BASE_URL}/app`,
    icon: WorkspaceIcon,
    tooltip: 'Espacios de trabajo',
  },
  {
    link: DESPIECE_BASE_URL,
    icon: DespieceIcon,
    tooltip: 'Desmaquetación',
  },
  {
    link: AV_PLUS_BASE_URL,
    icon: AVIcon,
    tooltip: 'AVPlus',
  },
];

export function PlatformsSwitcherMenu() {
  const { t } = useTranslation();

  return (
    <div className="flex gap-[8px] p-4">
      {PLATFORMS.map(({ link, icon: Icon, tooltip }) => (
        <Tooltip key={link} help={t(tooltip)} grow>
          <IconButton
            className={clsx('border border-[white]', {
              '!bg-accent-active-primary-30': window.location.href.startsWith(link),
            })}
            onClick={() => {
              window.open(link, '_blank');
            }}
          >
            <Icon className="text-[white]" size={IconSizeEnum.SM} />
          </IconButton>
        </Tooltip>
      ))}
    </div>
  );
}
